import request from '@/axios'

// 02-接收/拒绝用户
export function receiveOperation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/receiveOperation',
    method: 'post',
    data
  })
}

// 03-查看档案
export function getCustomerFileInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerFileInfo',
    method: 'post',
    data
  })
}

// 04-房屋信息
export function getCustomerHouseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerHouseInfo',
    method: 'post',
    data
  })
}

// 05-人口信息
export function getCustomerPopulationInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerPopulationInfo',
    method: 'post',
    data
  })
}

// 06-装修需求
export function getCustomerFitmentInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerFitmentInfo',
    method: 'post',
    data
  })
}

// 07-订单信息
export function getCustomerOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerOrderInfo',
    method: 'post',
    data
  })
}

// 08-设计方案
export function getOrderDesignDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getOrderDesignDetail',
    method: 'post',
    data
  })
}
// v2.9
// 05-跟进信息
export function getCustomerFollowInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/follow/getCustomerFollowInfo',
    method: 'post',
    data
  })
}
// 06-转设计
export function shiftDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/shiftDesigner',
    method: 'post',
    data
  })
}
// I-07-选材预览-空间分类
export function getPreviewCategory(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getPreviewCategory',
    method: 'post',
    data
  })
}
// I-08-选材预览-分类选材明细
export function getPreviewList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getPreviewList',
    method: 'post',
    data
  })
}
// 最新跟进信息
export function getNewCustomerFollowInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/follow/getNewCustomerFollowInfo',
    method: 'post',
    data
  })
}
// 04-获取电子合同
export function getContractInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getContractInfo',
    method: 'post',
    data
  })
}
// 用户基本信息
export function getCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/archives/getCustomerInfo',
    method: 'post',
    data
  })
}
